/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TrendButtonCreateMutationVariables = {|
  id: string
|};
export type TrendButtonCreateMutationResponse = {|
  +recipeUpdate: ?{|
    +recipe: ?{|
      +id: string,
      +isTrend: boolean,
    |}
  |}
|};
export type TrendButtonCreateMutation = {|
  variables: TrendButtonCreateMutationVariables,
  response: TrendButtonCreateMutationResponse,
|};
*/


/*
mutation TrendButtonCreateMutation(
  $id: ID!
) {
  recipeUpdate(input: {id: $id, isTrend: true}) {
    recipe {
      id
      isTrend
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "isTrend",
            "value": true
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTrend",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrendButtonCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrendButtonCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TrendButtonCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TrendButtonCreateMutation(\n  $id: ID!\n) {\n  recipeUpdate(input: {id: $id, isTrend: true}) {\n    recipe {\n      id\n      isTrend\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '60b2b8afe8a54fa33e09025b2f6fc2a5';

module.exports = node;
